export const ADD_SMS_TEMPLATE = "ADD_SMS_TEMPLATE"
export const GET_SMS_TEMPLATE = "GET_SMS_TEMPLATE"
export const ALL_SMS_TEMPLATE = "ALL_SMS_TEMPLATE"
export const EDIT_SMS_TEMPLATE = "EDIT_SMS_TEMPLATE"